<template>
  <!-- 充值弹窗 -->
  <el-dialog
    title="充值"
    :visible="visible"
    :modal-append-to-body="false"
    class="recharge-dialog-components"
    width="496px"
    :show-close="false"
    :before-close="close"
  >
    <div class="same_text">购买数量</div>
    <ul class="number_list">
      <li
        v-for="(item, index) in moneyList"
        :key="item.id"
        @click="moneyClick(index)"
        :class="[moneyIndex == index ? 'active_li' : '']"
      >
        <div class="top_d">
          <img
            :src="require('@/assets/img/dialog/mine_top_jinkela.png')"
            alt=""
          />
          <span>{{ item.gold }}</span>
        </div>
        <div class="bottom_d">
          <span style="font-size: 10px">￥</span>
          <span>{{ item.price }}</span>
        </div>
      </li>
    </ul>
    <div class="item_money">
      <span class="other_money">其他金额</span>
      <el-input
        v-model="inputMoney"
        placeholder="输入金额1-999的整数"
        style="width: 368px"
        @input="changeText"
      />
    </div>
    <div class="same_text">支付方式</div>
    <ul class="pay_method">
      <li
        v-for="(item, index) in payList"
        :key="item.id"
        @click="payIndex = index"
        :class="[payIndex == index ? 'active_li' : '']"
      >
        <img :src="item.g" alt="" />
        <span>{{ item.m }}</span>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer-my">
      <div class="cancel" @click="close">取消</div>
      <div class="confirm" @click="commit">确认</div>
    </span>
  </el-dialog>
</template>

<script>
import { post } from "../../util/http";

export default {
  data() {
    return {
      moneyList: [],
      moneyIndex: -1,

      payList: [
        // { id: "902", m: "微信", g: require("~/assets/img/dialog/mine_pay_weixin.png") },
        {
          id: "903",
          m: "支付宝",
          g: require("@/assets/img/dialog/mine_pay_zhifubao.png"),
        },
        // { id: "907", m: "银行卡", g: require("~/assets/img/dialog/mine_pay_yinhangka.png")}
      ],
      payIndex: 0,

      inputMoney: "",
    };
  },
  mounted() {
    post({ url: "/api/charge/chargePriceList" }).then(({ data }) => {
      this.moneyList = data.data;
    });
  },

  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    visible() {
      return this.$store.state.pay.isRecharge;
    },
  },

  methods: {
    close() {
      this.$store.commit("pay/rechargeShow", false);
      this.moneyIndex = -1;
      this.payIndex = 0;
      this.inputMoney = "";
    },

    changeText() {
      if (this.inputMoney.length > 0) {
        this.moneyIndex = -1;
      }
    },

    checkOrderNum(orderid) {
      post({
        url: "/api/charge/searchOrder",
        data: {
          pay_orderid: orderid,
        },
      }).then(({ data }) => {
        console.log(data);
      });
    },

    commit() {
      var price = 0;
      console.log(this.moneyIndex);
      if (this.moneyIndex == -1) {
        if (this.inputMoney.length < 0) {
          return;
        }
        price = this.inputMoney;
      } else {
        let payModel = this.moneyList[this.moneyIndex];
        price = payModel.price;
        // console.log(this.payList)
        // console.log(this.moneyIndex)
      }
      price = price.toString();
      post({
        url: "/api/charge/commitOrder",
        data: {
          // callback_host: window.location.host,
          callback_host: "https://api.zhou618.com",
          // callback_host :"https://sport.sun8tv.com",
          pay_amount: price,
          pay_bankcode: "903",
          pay_for_anchorid: this.userInfo.id,
          pay_product_type: 2,
          pay_productdesc: price,
          pay_productname: "克拉",
          pay_productnum: "1",
          token: this.userInfo.token,
          uid: this.userInfo.id,
        },
      }).then(({ data }) => {
        let model = data.data;
        var win = window.open("", "智能收银台");
        win.document.write(model.html_str);
        win.document.close();
        console.log(model.orderid);
      });
    },

    moneyClick(index) {
      if (this.moneyIndex == index) {
        this.moneyIndex = -1;
        return;
      }
      this.moneyIndex = index;
      this.inputMoney = "";
    },
  },
};
</script>

<style scoped lang="stylus">
/deep/ .el-dialog__body {
    padding: 0;
}

.recharge-dialog-components{
    .same_text{
        margin-top: 24px;
        margin-bottom: 16px;
        font-size: 14px;
        color: #666666;
        padding-left:24px;
    }
    .other_money{
        font-size: 14px;
        color: #666666;
        padding-left:24px;
        margin-right: 24px
    }
    .number_list{
        display: flex;
        flex-wrap: wrap;
        padding-left:24px;

        li{
            width: 100px;
            height: 88px;
            background: rgba(38,217,157,0.10);
            // border: 1px solid transparent;
            background: #F7F7F7;
            border-radius: 8px;
            margin-right:16px;
            box-sizing: border-box;
            margin-bottom: 16px;
            // overflow hidden
            cursor pointer

            .top_d{
                height: 56px;
                font-size: 14px;
                color: #666666;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow hidden
                border-radius: 8px 8px 0 0;
                img{
                    width 16px;
                    height: 16px
                    margin-right: 4px
                }
            }
            .bottom_d{
                // width: 100px;
                height: 32px;
                background: #F0F0F0;
                font-size: 20px;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius:  0 0 8px 8px;
            }
        }
        .active_li{
            width: 100px;
            height: 88px;
            background: linear-gradient(101.98deg, #FF3838 10.8%, #D02D54 95.33%);

            border-radius: 8px;
            .top_d{
                height: 56px;
                font-size: 14px;
                color: #26D99D;
                border: 1px solid #26D99D;
                border-bottom: none;
            }
            .bottom_d{
                background: #26D99D;
                color: #FFFFFF;
            }
        }
    }
    .pay_method{
        padding-left:24px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 48px;
        li{
            width: 106px;
            height: 48px;
            background: #F7F7F7;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #666666;
            overflow hidden
            margin-right: 16px;
            cursor pointer
            img{
                width: 24px;
                height: 24px;
                margin-right: 8px;
            }

        }
        .active_li{
          background: linear-gradient(101.98deg, #FF3838 10.8%, #D02D54 95.33%);
          border: 1px solid #FF3838;
        }
    }

}
</style>
